<template>
  <div class="content-wrapper" style="text-align: left">
    <div class="row">
      <div class="col-xs-12 col-sm-8 col-lg-8 col-md-8">
        <div><label class="e-text">Paquetes Disponibles</label></div>
        <div class="align-self-stretch" style="width: 100%">
          <ejs-dropdownlist
            ref="packagesDropDown"
            id="packagesDropDown"
            :dataSource="packages"
            :fields="fields"
            v-model="selectedPackage"
            :value="selectedPackage"
            :showClearButton="true"
            placeholder="Paquete"
            width="100%"
            :readonly="isFormReadOnly || !showData"
          ></ejs-dropdownlist>
          <span
            class="help e-text small"
            :class="{ 'e-warning': hasError('selectedPackage') }"
            v-text="m_errors.selectedPackage"
          >
          </span>
        </div>
      </div>
      <div class="col-xs-12 col-sm-4 col-lg-4 col-md-4">
        <div><label class="e-text">&nbsp;</label></div>
        <ejs-button
          cssClass="e-flat e-noback e-info"
          @click.native="addPackage"
          iconCss="e-icons icon-plus inline-command"
          v-if="showSaveButton"
          :disabled="disableButtons"
        >
          Adicionar Paquete</ejs-button
        >
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12 col-sm-12 col-lg-12 col-md-12">
        <h6>Paquetes</h6>
        <ejs-grid
          ref="gridConditionPackages"
          class="r-space"
          :actionBegin="onPackagesActionBegin"
          :actionComplete="onPackagesActionComplete"
          :toolbar="customToolbar"
          :toolbarClick="toolbar_click"
          :dataSource="gridPackagesData"
          locale="es-CO"
          :query="query"
          :allowSorting="false"
          :allowSelection="true"
          :allowExcelExport="false"
          :allowFiltering="false"
          :allowPaging="true"
          :allowGrouping="false"
          :pageSettings="pageSettings"
          :editSettings="editSettings"
          :selectionSettings="selectionSettings"
        >
          <e-columns>
            <e-column
              field="selected"
              headerText="Seleccionado"
              textAlign="center"
              :width="90"
              clipMode="EllipsisWithTooltip"
              :required="true"
              editType="booleanedit"
              displayAsCheckBox="true"
              :allowEditing="true"
            ></e-column>
            <e-column
              field="conditionId"
              headerText="Id Condicion"
              textAlign="Right"
              :width="90"
              :minWidth="90"
              clipMode="EllipsisWithTooltip"
              :allowEditing="false"
              :visible="false"
              defaultValue="0"
            ></e-column>
            <e-column
              field="packageId"
              headerText="Id Paquete"
              :isPrimaryKey="true"
              textAlign="left"
              :width="90"
              :minWidth="90"
              clipMode="EllipsisWithTooltip"
              :allowEditing="false"
              :visible="true"
              defaultValue="0"
            ></e-column>
            <e-column
              field="name"
              headerText="Nombre"
              :width="150"
              :minWidth="150"
              :allowEditing="false"
              clipMode="EllipsisWithTooltip"
            ></e-column>
            <e-column
              field="isPreviewEnabled"
              headerText="Previsualización"
              textAlign="center"
              :width="90"
              clipMode="EllipsisWithTooltip"
              :required="true"
              editType="booleanedit"
              displayAsCheckBox="true"
              :allowEditing="false"
            ></e-column>
            <e-column
              field="queueIdCombo"
              headerText="Cola de Proceso"
              :width="200"
              :minWidth="200"
              editType="dropdownedit"
              :edit="queueParams"
              clipMode="EllipsisWithTooltip"
            ></e-column>
            <e-column
              field="isActive"
              headerText="Activo"
              textAlign="center"
              :width="90"
              clipMode="EllipsisWithTooltip"
              :required="true"
              editType="booleanedit"
              displayAsCheckBox="true"
              :allowEditing="false"
            ></e-column>
          </e-columns>
        </ejs-grid>
        <span
          class="help e-text small"
          :class="{ 'e-warning': hasError('listConditionPackages') }"
          v-html="m_errors.listConditionPackages"
        >
        </span>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12 col-sm-12 col-lg-12 col-md-12">
        <h6>Documentos</h6>
        <ejs-grid
          ref="gridConditionDocuments"
          class="r-space"
          :actionBegin="onDocumentsActionBegin"
          :actionComplete="onDocumentsActionComplete"
          :toolbar="customToolbar"
          :toolbarClick="toolbar_click"
          :dataSource="gridDocumentsData"
          locale="es-CO"
          :query="query"
          :allowSorting="false"
          :allowSelection="true"
          :allowExcelExport="false"
          :allowFiltering="false"
          :allowPaging="true"
          :allowGrouping="false"
          :pageSettings="pageSettings"
          :editSettings="editSettings"
          :selectionSettings="selectionSettings"
          :queryCellInfo="setStyle"
        >
          <e-columns>
            <e-column
              field="selected"
              headerText="Seleccionado"
              textAlign="center"
              :width="90"
              clipMode="EllipsisWithTooltip"
              :required="true"
              editType="booleanedit"
              displayAsCheckBox="true"
              :allowEditing="true"
            ></e-column>
            <e-column
              field="conditionId"
              headerText="Id Condicion"
              textAlign="Right"
              :width="90"
              :minWidth="90"
              clipMode="EllipsisWithTooltip"
              :visible="false"
              defaultValue="0"
            ></e-column>
            <e-column
              field="documentId"
              headerText="Id Documento"
              :isPrimaryKey="true"
              textAlign="left"
              :width="100"
              :minWidth="100"
              clipMode="EllipsisWithTooltip"
              :allowEditing="false"
              :visible="true"
              defaultValue="0"
            ></e-column>
            <e-column
              field="name"
              headerText="Nombre"
              :width="150"
              :minWidth="150"
              :allowEditing="false"
              clipMode="EllipsisWithTooltip"
            ></e-column>
            <e-column
              field="protectionTypeIdCombo"
              headerText="Tipo de Protección"
              clipMode="EllipsisWithTooltip"
              :width="200"
              :minWidth="200"
              editType="dropdownedit"
              :edit="protectionTypeParams"
            ></e-column>
            <e-column
              field="passwordValue"
              headerText="Contraseña"
              clipMode="EllipsisWithTooltip"
              :width="150"
              :minWidth="150"
              :allowEditing="true"
            ></e-column>
            <e-column
              field="isActive"
              headerText="Activo"
              textAlign="center"
              :width="90"
              clipMode="EllipsisWithTooltip"
              :required="true"
              editType="booleanedit"
              displayAsCheckBox="true"
              :allowEditing="false"
            ></e-column>
            <e-column
              field="packageId"
              headerText="Id Paquete"
              :isPrimaryKey="true"
              textAlign="left"
              :width="100"
              :minWidth="100"
              clipMode="EllipsisWithTooltip"
              :allowEditing="false"
              :visible="false"
              defaultValue="0"
            ></e-column>
            <e-column
              field="packageName"
              headerText="Paquete"
              textAlign="left"
              :width="100"
              :minWidth="100"
              clipMode="EllipsisWithTooltip"
              :allowEditing="false"
              :visible="true"
              defaultValue="0"
            ></e-column>
          </e-columns>
        </ejs-grid>
        <span
          class="help e-text small"
          :class="{ 'e-warning': hasError('listConditionDocuments') }"
          v-html="m_errors.listConditionDocuments"
        >
        </span>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12 col-sm-12 col-lg-12 col-md-12">
        <h6>Formatos</h6>
        <ejs-grid
          ref="gridConditionFormats"
          class="r-space"
          :actionBegin="onFormatsActionBegin"
          :actionComplete="onFormatsActionComplete"
          :dataSource="gridFormatsData"
          :toolbar="customToolbar"
          :toolbarClick="toolbar_click"
          locale="es-CO"
          :query="query"
          :allowSorting="false"
          :allowSelection="true"
          :allowExcelExport="false"
          :allowFiltering="false"
          :allowPaging="true"
          :allowGrouping="false"
          :pageSettings="pageSettings"
          :editSettings="editSettings"
          :selectionSettings="selectionSettings"
        >
          <e-columns>
            <e-column
              field="selected"
              headerText="Seleccionado"
              textAlign="center"
              :width="90"
              clipMode="EllipsisWithTooltip"
              :required="true"
              editType="booleanedit"
              displayAsCheckBox="true"
              :allowEditing="true"
            ></e-column>
            <e-column
              field="conditionId"
              headerText="Id Condicion"
              textAlign="Right"
              :width="90"
              :minWidth="90"
              clipMode="EllipsisWithTooltip"
              :visible="false"
              defaultValue="0"
            ></e-column>
            <e-column
              field="packageId"
              headerText="Id Paquete"
              :isPrimaryKey="true"
              textAlign="Right"
              :width="90"
              :minWidth="90"
              clipMode="EllipsisWithTooltip"
              :visible="false"
              defaultValue="0"
            ></e-column>
            <e-column
              field="documentId"
              headerText="Id Documento"
              :isPrimaryKey="true"
              textAlign="Right"
              :width="90"
              :minWidth="90"
              clipMode="EllipsisWithTooltip"
              :visible="false"
              defaultValue="0"
            ></e-column>

            <e-column
              field="formatId"
              headerText="Id Formato"
              :isPrimaryKey="true"
              textAlign="left"
              :width="60"
              :minWidth="60"
              clipMode="EllipsisWithTooltip"
              :allowEditing="false"
              :visible="true"
              defaultValue="0"
            ></e-column>
            <e-column
              field="name"
              headerText="Nombre"
              :width="150"
              :minWidth="150"
              :allowEditing="false"
              clipMode="EllipsisWithTooltip"
            ></e-column>
            <e-column
              field="isActive"
              headerText="Activo"
              textAlign="center"
              :width="90"
              clipMode="EllipsisWithTooltip"
              :required="true"
              editType="booleanedit"
              displayAsCheckBox="true"
              :allowEditing="false"
            ></e-column>
            <e-column
              field="packageName"
              headerText="Paquete"
              textAlign="left"
              :width="100"
              :minWidth="100"
              clipMode="EllipsisWithTooltip"
              :allowEditing="false"
              :visible="true"
              defaultValue="0"
            ></e-column>
            <e-column
              field="documentName"
              headerText="Documento"
              textAlign="left"
              :width="100"
              :minWidth="100"
              clipMode="EllipsisWithTooltip"
              :allowEditing="false"
              :visible="true"
              defaultValue="0"
            ></e-column>
          </e-columns>
        </ejs-grid>
        <span
          class="help e-text small"
          :class="{ 'e-warning': hasError('listConditionFormats') }"
          v-html="m_errors.listConditionFormats"
        >
        </span>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12 col-sm-12 col-lg-12 col-md-12">
        <h6>Integraciones</h6>
        <ejs-grid
          ref="gridConditionIntegrations"
          class="r-space"
          :dataSource="gridIntegrationsData"
          :toolbar="customToolbar"
          :toolbarClick="toolbar_click"
          locale="es-CO"
          :query="query"
          :allowSorting="false"
          :allowSelection="true"
          :allowExcelExport="false"
          :allowFiltering="false"
          :allowPaging="true"
          :allowGrouping="false"
          :pageSettings="pageSettings"
          :editSettings="editSettings"
          :selectionSettings="selectionSettings"
        >
          <e-columns>
            <e-column
              field="selected"
              headerText="Seleccionado"
              textAlign="center"
              :width="90"
              clipMode="EllipsisWithTooltip"
              :required="true"
              editType="booleanedit"
              displayAsCheckBox="true"
              :allowEditing="true"
            ></e-column>
            <e-column
              field="conditionId"
              headerText="Id Condicion"
              textAlign="Right"
              :width="90"
              :minWidth="90"
              clipMode="EllipsisWithTooltip"
              :visible="false"
              defaultValue="0"
            ></e-column>
            <e-column
              field="integrationId"
              headerText="Id Integración"
              :isPrimaryKey="true"
              textAlign="left"
              :width="90"
              :minWidth="90"
              clipMode="EllipsisWithTooltip"
              :visible="true"
              defaultValue="0"
            ></e-column>
            <e-column
              field="name"
              headerText="Nombre"
              :width="150"
              :minWidth="150"
              :allowEditing="false"
              clipMode="EllipsisWithTooltip"
            ></e-column>
            <e-column
              field="packageName"
              headerText="Paquete"
              textAlign="left"
              :width="100"
              :minWidth="100"
              clipMode="EllipsisWithTooltip"
              :visible="true"
              :allowEditing="false"
              defaultValue="0"
            ></e-column>
          </e-columns>
        </ejs-grid>
        <span
          class="help e-text small"
          :class="{ 'e-warning': hasError('listConditionIntegrations') }"
          v-html="m_errors.listConditionIntegrations"
        >
        </span>
      </div>
    </div>

    <div class="row pull-right">
      <div class="col-xs-12 col-sm-12">
        <div class="e-btn-group">
          <ejs-button
            @click.native="validateForm"
            :isPrimary="true"
            iconCss="e-icons icon-save inline-command"
            cssClass="e-flat e-noback"
            v-if="showSaveButton"
            >Grabar</ejs-button
          >
          <ejs-button
            @click.native="close()"
            iconCss="e-icons icon-cancel inline-command"
            cssClass="e-flat e-noback"
            v-if="showSaveButton"
          >
            Cancelar</ejs-button
          >
        </div>
        <div>
          <span class="help e-text small">&nbsp;</span>
        </div>
        <div>
          <span class="help e-text small">&nbsp;</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
/*import { object, string, number, yup, when } from "yup";*/

import { FormActionEnum, ProtectionTypeEnum } from "../../services/enums.js";
import PermissionMixin from "../../mixins/PermissionMixin";
import ToastMixin from "../../mixins/ToastMixin";
import { DropDownListPlugin } from "@syncfusion/ej2-vue-dropdowns";
import { DropDownList } from "@syncfusion/ej2-dropdowns";
/* Plugins de Syncfusion */
import { ButtonPlugin } from "@syncfusion/ej2-vue-buttons";

import {
  GridPlugin,
  Edit,
  Page,
  Selection,
  CommandColumn,
  Toolbar,
  Sort
} from "@syncfusion/ej2-vue-grids";

Vue.use(GridPlugin);
Vue.use(ButtonPlugin);
Vue.use(DropDownListPlugin);

export default Vue.extend({
  name: "print-conditions-data",
  mixins: [PermissionMixin, ToastMixin],
  async beforeDestroy() {},
  computed: {
    showSaveButton() {
      return (
        (this.formAction === FormActionEnum.ADD ||
          this.formAction === FormActionEnum.EDIT) &&
        this.showData
      );
    },
    isFormReadOnly() {
      var ret = false;
      switch (this.formAction) {
        case FormActionEnum.ADD:
          break;
        case FormActionEnum.EDIT:
          break;
        case FormActionEnum.VIEW:
          ret = true;
          break;
        case FormActionEnum.DELETE:
          ret = true;
          break;
      }
      if (!this.showData) ret = true;

      return ret;
    },
    disableButtons() {
      return this.isSaving;
    },
    customToolbar() {
      var canEdit = this.hasPermission("CanEdit");
      var toolbar = [];
      if (canEdit) toolbar.push("Edit");
      toolbar.push("Update");
      toolbar.push("Cancel");
      return toolbar;
    },
    editSettings() {
      var canEdit = this.hasPermission("CanEdit");
      if (!this.showData) canEdit = false;
      return {
        showDeleteConfirmDialog: true,
        allowEditing: canEdit,
        allowEditOnDblClick: false,
        allowAdding: false,
        allowDeleting: false,
        mode: "Normal"
      };
    }
  },
  data() {
    var instance = this;
    return {
      /* Datos del Componente*/
      isValid: false,
      validationSchema: {},
      m_errors: {},
      m_data: {},
      fields: { text: "name", value: "id" },
      packages: null,
      documents: null,
      formats: null,
      formData: null,
      formAction: null,
      gridPackagesData: [],
      gridDocumentsData: [],
      gridFormatsData: [],
      gridIntegrationsData: [],
      selectedPackage: null,
      isInPackageGridEdition: false,
      isInDocumentGridEdition: false,
      isInFormatGridEdition: false,
      query: "",
      pageSettings: { pageCount: 5, pageSize: 10 },
      isSaving: false,
      selectionSettings: {},
      isDialogOpen: false,
      queues: [],
      queueElement: null,
      queueCombo: null,
      queueParams: {
        create: () => {
          instance.queueElement = document.createElement("input");
          return instance.queueElement;
        },
        read: () => {
          return instance.getQueueById(instance.queueCombo.value);
        },
        destroy: () => {
          instance.queueCombo.destroy();
        },
        write: (args) => {
          instance.queueCombo = new DropDownList({
            dataSource: instance.queues,
            fields: { value: "id", text: "name" },
            placeholder: "Seleccione Cola",
            floatLabelType: "Never"
          });
          instance.queueCombo.value =
            instance.getValueFromQueueText(args.rowData.queueIdCombo) ?? null;
          instance.queueCombo.appendTo(instance.queueElement);
        }
      },
      protectionTypes: [],
      protectionTypeElement: null,
      protectionTypeCombo: null,
      protectionTypeParams: {
        create: () => {
          instance.protectionTypeElement = document.createElement("input");
          return instance.protectionTypeElement;
        },
        read: () => {
          return instance.getProtectionTypeById(
            instance.protectionTypeCombo.value
          );
        },
        destroy: () => {
          instance.protectionTypeCombo.destroy();
        },
        write: (args) => {
          instance.protectionTypeCombo = new DropDownList({
            dataSource: instance.protectionTypes,
            fields: { value: "id", text: "name" },
            placeholder: "Seleccione Tipo Protección",
            floatLabelType: "Never"
          });
          instance.protectionTypeCombo.value =
            instance.getValueFromProtectionTypeText(
              args.rowData.protectionTypeIdCombo
            ) ?? null;
          instance.protectionTypeCombo.appendTo(instance.protectionTypeElement);
        }
      }
    };
  },
  beforeMount() {
    this.m_data = this.$store.dispatch(
      "printConditions/initPrintCondition",
      true
    );
  },
  created() {},
  async mounted() {},
  methods: {
    async DialogOpen() {
      try {
        //Esto es lo que tiene loco el Formulario!!
        this.$forceUpdate();

        this.isDialogOpen = true;

        this.packages = JSON.parse(
          JSON.stringify(this.$store.getters["packages/allPackages"])
        );

        var queues = await this.$store.dispatch("packages/getAllQueues");
        this.queues = JSON.parse(JSON.stringify(queues));

        var protectionTypes = await this.$store.dispatch(
          "minosParameters/getParameterValuesByCode",
          { code: "PROTECTION_TYPE", returnObject: true }
        );

        this.protectionTypes = protectionTypes
          //.filter((x) => x.active === true)
          .map(function (row) {
            return { id: row.integerValue, name: row.description };
          });

        this.documents = JSON.parse(
          JSON.stringify(this.$store.getters["documents/allDocuments"])
        );

        this.formats = JSON.parse(
          JSON.stringify(this.$store.getters["formats/allFormats"])
        );

        this.integrations = JSON.parse(
          JSON.stringify(this.$store.getters["integrations/allIntegrations"])
        );

        //this.setValues();
        this.isDialogOpen = false;
      } catch (error) {
        console.log(error);
        this.showToast(error.message);
      }
    },
    packageSelected(args) {
      var instance = this;
      var packages = [];

      if (Array.isArray(args)) {
        packages = args;
      } else {
        packages.push(args);
      }

      packages.forEach((pack) => {
        var currentPackage = instance.packages.find(
          (x) => x.id == pack.packageId
        );

        var existent = this.gridDocumentsData.find(
          (x) => x.packageId == pack.packageId
        );

        if (
          (existent == null || existent == undefined) &&
          currentPackage != undefined &&
          currentPackage != null
        ) {
          if (
            currentPackage.documents != undefined &&
            currentPackage.documents.length > 0
          ) {
            var packageDocuments = currentPackage.documents
              //.filter((doc) => doc.isActive)
              .map(function (row) {
                return row.documentId;
              });
            var listDocuments = instance.documents
              .filter((doc) => packageDocuments.includes(doc.id))
              .map(function (row) {
                var cDoc = currentPackage.documents.find(
                  (x) => x.documentId == row.id
                );

                return {
                  conditionId: pack.conditionId,
                  packageId: pack.packageId,
                  packageName: pack.name,
                  documentId: row.id,
                  name: row.name,
                  isActive: row.isActive && cDoc.isActive,
                  selected: false
                };
              });
            listDocuments.forEach((document) => {
              this.gridDocumentsData.push(document);
            });
          }
        }

        var intExistent = this.gridIntegrationsData.find(
          (x) => x.packageId == pack.packageId
        );

        if (
          (intExistent == null || intExistent == undefined) &&
          currentPackage != undefined &&
          currentPackage != null
        ) {
          if (
            currentPackage.integrations != undefined &&
            currentPackage.integrations.length > 0
          ) {
            var packageIntegrations = currentPackage.integrations
              //.filter((int) => int.isActive)
              .map(function (row) {
                return row.integrationId;
              });
            var listIntegrations = instance.integrations
              .filter((int) => packageIntegrations.includes(int.id))
              .map(function (row) {
                return {
                  conditionId: pack.conditionId,
                  packageId: pack.packageId,
                  packageName: pack.name,
                  integrationId: row.id,
                  name: row.name,
                  selected: false
                };
              });
            listIntegrations.forEach((integration) => {
              this.gridIntegrationsData.push(integration);
            });
          }
        }
      });
      this.$refs.gridConditionDocuments.ej2Instances.refresh();
      this.$refs.gridConditionIntegrations.ej2Instances.refresh();
    },
    packageDeselected(data) {
      this.gridDocumentsData = this.gridDocumentsData.filter(
        (x) => x.packageId != data.packageId
      );
      this.gridFormatsData = this.gridFormatsData.filter(
        (x) => x.packageId != data.packageId
      );
      this.gridIntegrationsData = this.gridIntegrationsData.filter(
        (x) => x.packageId != data.packageId
      );

      this.$refs.gridConditionDocuments.ej2Instances.refresh();
      this.$refs.gridConditionFormats.ej2Instances.refresh();
      this.$refs.gridConditionIntegrations.ej2Instances.refresh();
    },
    documentSelected(args) {
      var instance = this;
      var documents = [];
      if (Array.isArray(args)) {
        documents = args;
      } else {
        documents.push(args);
      }

      documents.forEach((doc) => {
        var currentDocument = instance.documents.find(
          (x) => x.id == doc.documentId
        );
        var existent = instance.gridFormatsData.find(
          (x) => x.packageId == doc.packageId && x.documentId == doc.documentId
        );

        if (existent == null || existent == undefined) {
          if (
            currentDocument.formats != undefined &&
            currentDocument.formats.length > 0
          ) {
            var documentFormats = currentDocument.formats
              //.filter((doc) => doc.isActive)
              .map(function (row) {
                return row.formatId;
              });

            var listFormats = instance.formats
              .filter((doc) => documentFormats.includes(doc.id))
              .map(function (row) {
                var dcFmt = currentDocument.formats.find(
                  (x) => x.formatId == row.id
                );

                return {
                  conditionId: doc.conditionId,
                  packageId: doc.packageId,
                  documentId: doc.documentId,
                  packageName: doc.packageName,
                  documentName: doc.name,
                  formatId: row.id,
                  name: row.name,
                  isActive: row.isActive && dcFmt.isActive,
                  selected: false
                };
              });

            listFormats.forEach((format) => {
              this.gridFormatsData.push(format);
            });
          }
        }
      });

      this.$refs.gridConditionFormats.ej2Instances.refresh();
    },
    documentDeselected(data) {
      this.gridFormatsData = this.gridFormatsData.filter(
        (x) => x.documentId != data.documentId
      );
      this.$refs.gridConditionFormats.ej2Instances.refresh();
    },
    getPackageListData() {
      var instance = this;

      var dPackages = JSON.parse(JSON.stringify(instance.m_data.packages));

      var hasPackages = dPackages && dPackages.length > 0;
      var hasPackagesAux = instance.packages && instance.packages.length > 0;
      if (!hasPackagesAux) return [];

      if (hasPackagesAux && hasPackages) {
        var ret = dPackages.map(function (item) {
          var existent = instance.packages.find((x) => x.id == item.packageId);
          if (existent != null && existent != undefined) {
            var newItem = {
              conditionId: item.conditionId,
              packageId: item.packageId,
              name: existent.name,
              isPreviewEnabled: existent.isPreviewEnabled,
              queueId: item.queueId,
              isActive: existent.isActive,
              queueIdCombo: instance.getQueueById(item.queueId),
              selected: true
            };
            return newItem;
          }
        });
        return ret;
      } else {
        return [];
      }
    },
    close() {
      this.$emit("formClosed");
    },
    clearData() {
      this.gridPackagesData = [];
      this.gridDocumentsData = [];
      this.gridFormatsData = [];
      this.gridIntegrationsData = [];
      this.$refs.gridConditionPackages.ej2Instances.refresh();
      this.$refs.gridConditionDocuments.ej2Instances.refresh();
      this.$refs.gridConditionFormats.ej2Instances.refresh();
      this.$refs.gridConditionIntegrations.ej2Instances.refresh();
      this.m_data = {};
      this.packages = [];
      this.selectedPackage = null;
      this.clearErrors();
    },
    clearErrors() {
      this.m_errors = {};
    },
    addPackage() {
      var selected = this.packages.find((x) => x.id == this.selectedPackage);
      if (selected == null || selected == undefined) return;

      var comboText = null;
      var hasQueue = !!selected.queueId;
      if (hasQueue) comboText = this.getQueueById(selected.queueId);

      var newItem = {
        conditionId: this.m_data.conditionId,
        packageId: selected.id,
        name: selected.name,
        isPreviewEnabled: selected.isPreviewEnabled,
        queueId: selected.queueId,
        queueIdCombo: comboText,
        isActive: selected.isActive,
        selected: false
      };

      if (this.gridPackagesData && this.gridPackagesData.length > 0) {
        var existent = this.gridPackagesData.find(
          (x) =>
            x.conditionId == newItem.conditionId &&
            x.packageId == newItem.packageId
        );
      }

      if (existent != null || existent != undefined) {
        this.showToast(
          "Existente!",
          "El paquete ya ha sido adicionado a la condicion actual.",
          2000
        );
        return;
      }
      this.gridPackagesData.push(newItem);
      this.$refs.gridConditionPackages.ej2Instances.refresh();
    },
    async onPackagesActionBegin(args) {
      if (args.requestType === "refresh") {
        this.$refs.gridConditionPackages.showSpinner();
      }

      if (args.action === "edit" && args.requestType === "save") {
        if (!this.validateDataPackages(args.data)) {
          args.cancel = true;
          return;
        }
      }
    },
    onPackagesActionComplete(args) {
      if (args.requestType === "refresh") {
        this.$refs.gridConditionPackages.hideSpinner();
      }

      if (args.name == "actionComplete" && args.requestType == "beginEdit") {
        if (!args.cancel) this.isInPackageGridEdition = true;
      }
      if (
        args.name == "actionComplete" &&
        (args.requestType == "save" || args.requestType == "cancel")
      ) {
        if (!args.cancel) {
          this.isInPackageGridEdition = false;
          if (args.data.selected) {
            this.packageSelected(args.data);
          } else {
            this.packageDeselected(args.data);
          }
        }
      }
    },
    async onDocumentsActionBegin(args) {
      if (args.requestType === "refresh") {
        this.$refs.gridConditionDocuments.showSpinner();
      }

      if (args.action === "edit" && args.requestType === "save") {
        if (!this.validateDataDocuments(args.data)) {
          args.cancel = true;
          return;
        }
      }
    },
    onDocumentsActionComplete(args) {
      if (args.requestType === "refresh") {
        this.$refs.gridConditionDocuments.hideSpinner();
      }

      if (args.name == "actionComplete" && args.requestType == "beginEdit") {
        if (!args.cancel) this.isInDocumentGridEdition = true;
      }
      if (
        args.name == "actionComplete" &&
        (args.requestType == "save" || args.requestType == "cancel")
      ) {
        if (!args.cancel) {
          this.isInDocumentGridEdition = false;
          if (args.data.selected) {
            this.documentSelected(args.data);
          } else {
            this.documentDeselected(args.data);
          }
        }
      }
    },
    async onFormatsActionBegin(args) {
      if (args.requestType === "refresh") {
        this.$refs.gridConditionFormats.showSpinner();
      }

      if (args.name == "actionBegin" && args.requestType == "save") {
        this.BackupFormats = JSON.parse(
          JSON.stringify(this.gridFormatsData, true)
        );
      }
    },
    onFormatsActionComplete(args) {
      if (args.requestType === "refresh") {
        this.$refs.gridConditionFormats.hideSpinner();
      }

      if (args.name == "actionComplete" && args.requestType == "beginEdit") {
        if (!args.cancel) this.isInFormatGridEdition = true;
      }
      if (
        args.name == "actionComplete" &&
        (args.requestType == "save" || args.requestType == "cancel")
      ) {
        //Actualizar manualmente forzando la reactividad de Vue;

        if (args.requestType == "save") {
          var data = args.data;
          this.BackupFormats;

          var itemIndex = this.BackupFormats.findIndex(
            (x) =>
              x.conditionId == data.conditionId &&
              x.packageId == data.packageId &&
              x.documentId == data.documentId &&
              x.formatId == data.formatId
          );

          this.BackupFormats[itemIndex] = data;

          this.gridFormatsData = this.BackupFormats.slice();
        }
        this.$refs.gridConditionFormats.ej2Instances.refresh();

        // var otherItemIndex = this.gridFormatsData.findIndex(
        //   (x) =>
        //     x.conditionId == 41 &&
        //     x.packageId == 9 &&
        //     x.documentId == 8 &&
        //     x.formatId == 12
        // );

        // console.log("otherItemIndex", otherItemIndex);
        // console.log("data", JSON.parse(JSON.stringify(data, true)));
        // console.log(
        //   "data",
        //   JSON.parse(JSON.stringify(this.gridFormatsData, true))
        // );

        // // Vue.set(this.gridFormatsData, itemIndex, data);
        // console.log(this.gridFormatsData);
        // console.log(args);
        // console.log(args.selected);
        this.isInFormatGridEdition = false;
      }
    },
    getErrorsPackages(data) {
      var listaErrores = [];
      var queueId = this.getValueFromQueueText(data.queueIdCombo);
      if (queueId == null || queueId == undefined || queueId == 0) {
        listaErrores.push(
          'Debe especificar una Cola de Proceso para:"' + data.name + '"'
        );
      }
      return listaErrores.join("<br/>");
    },
    getErrorsDocuments(data) {
      var listaErrores = [];
      var protectionType = this.getValueFromProtectionTypeText(
        data.protectionTypeIdCombo
      );
      if (
        protectionType == null ||
        protectionType == undefined ||
        protectionType == 0
      ) {
        listaErrores.push(
          'Debe especificar un Tipo de Proteccion para:"' + data.name + '"'
        );
      }

      if (
        protectionType != null &&
        protectionType != undefined &&
        protectionType == 3 &&
        (data.passwordValue == null ||
          data.passwordValue == undefined ||
          data.passwordValue == "")
      ) {
        listaErrores.push(
          'Debe especificar una Contraseña para:"' + data.name + '"'
        );
      }

      return listaErrores.join("<br/>");
    },
    validateDataPackages(data) {
      var isValidData = true;
      var listaErrores = "";

      listaErrores = this.getErrorsPackages(data);

      if (listaErrores) {
        Vue.set(this.m_errors, "listConditionPackages", listaErrores);
        this.showToast(
          "Validacion fallida",
          "Por favor verifique los errores listados en la parte inferior de los paquetes!",
          2000
        );
        isValidData = false;
      } else {
        Vue.set(this.m_errors, "listConditionPackages", "");
      }

      return isValidData;
    },
    validateDataDocuments(data) {
      var isValidData = true;
      var listaErrores = "";

      listaErrores = this.getErrorsDocuments(data);

      if (listaErrores) {
        Vue.set(this.m_errors, "listConditionDocuments", listaErrores);
        this.showToast(
          "Validacion fallida",
          "Por favor verifique los errores listados en la parte inferior de los documentos!",
          2000
        );
        isValidData = false;
      } else {
        Vue.set(this.m_errors, "listConditionDocuments", "");
      }

      return isValidData;
    },
    async toolbar_click() {},
    hasError(field) {
      return !!this.m_errors[field];
    },
    async validateForm() {
      this.isValid = false;
      try {
        this.m_errors = {};
        var valid = await this.validateData();
        if (!valid) return;
        this.getData();
        this.$emit("saveData", this.m_data);
      } catch (error) {
        if (error.inner != undefined) {
          error.inner.forEach((error) => {
            Vue.set(this.m_errors, error.path, error.message);
          });
        } else {
          console.log(error);
        }
      }
    },
    validateData() {
      var isValid = true;
      var listaErrores = [];

      var packages = this.gridPackagesData.filter((x) => x.selected);

      packages.forEach((pack) => {
        var errorPack = this.getErrorsPackages(pack);
        if (errorPack) listaErrores.push(errorPack);
      });

      if (packages.length == 0)
        listaErrores.push("Debe seleccionar al menos un Paquete");

      if (listaErrores.length > 0) {
        var _validaciones = listaErrores.join("<br/>");
        Vue.set(this.m_errors, "listConditionPackages", _validaciones);
        isValid = false;
      } else {
        Vue.set(this.m_errors, "listConditionPackages", "");
      }

      listaErrores = [];
      var documents = this.gridDocumentsData.filter((x) => x.selected);

      documents.forEach((doc) => {
        var errorDoc = this.getErrorsDocuments(doc);
        if (errorDoc) listaErrores.push(errorDoc);
      });

      if (documents.length == 0)
        listaErrores.push("Debe seleccionar al menos un Documento");

      if (listaErrores.length > 0) {
        var _validacionesDoc = listaErrores.join("<br/>");
        Vue.set(this.m_errors, "listConditionDocuments", _validacionesDoc);
        isValid = false;
      } else {
        Vue.set(this.m_errors, "listConditionDocuments", "");
      }

      var formats = this.gridFormatsData.filter((x) => x.selected);
      if (formats.length == 0) {
        Vue.set(
          this.m_errors,
          "listConditionFormats",
          "Debe seleccionar al menos un Formato"
        );
        isValid = false;
      } else {
        Vue.set(this.m_errors, "listConditionFormats", "");
      }

      var integrations = this.gridIntegrationsData.filter((x) => x.selected);
      if (integrations.length == 0) {
        Vue.set(
          this.m_errors,
          "listConditionIntegrations",
          "Debe seleccionar al menos una Integración"
        );
        isValid = false;
      } else {
        Vue.set(this.m_errors, "listConditionIntegrations", "");
      }

      if (!isValid) {
        this.showToast(
          "Validacion fallida",
          "Por favor verifique los errores listados!",
          2000
        );
      }
      return isValid;
    },
    getData() {
      var packages = [];
      this.gridPackagesData
        .filter((x) => x.selected)
        .forEach((item) => {
          var queueId = this.getValueFromQueueText(item.queueIdCombo);
          packages.push({
            conditionId: item.conditionId,
            packageId: item.packageId,
            queueId: queueId
          });
        });
      this.m_data.packages = packages;

      var documents = [];
      this.gridDocumentsData
        .filter((x) => x.selected)
        .forEach((item) => {
          var protectionType = this.getValueFromProtectionTypeText(
            item.protectionTypeIdCombo
          );
          var password =
            item.passwordValue == "****" ||
            item.protectionType == ProtectionTypeEnum.NO_PROTECTION
              ? ""
              : item.passwordValue;
          documents.push({
            conditionId: item.conditionId,
            packageId: item.packageId,
            documentId: item.documentId,
            protectionType: protectionType,
            passwordValue: password
          });
        });
      this.m_data.documents = documents;
      this.m_data.formats = this.gridFormatsData.filter((x) => x.selected);
      this.m_data.integrations = this.gridIntegrationsData.filter(
        (x) => x.selected
      );
    },
    setFormData(data, action) {
      this.formData = data;
      this.setValues();
      this.formAction = action;
    },
    getValueFromQueueText(value) {
      if (value == null) return null;
      var values = value.split("-");

      return parseInt(values[0]) || null;
    },
    getQueueById(id) {
      var value = this.queues.find((x) => x.id == id);
      if (value) return value.id + "-" + value.name;
      else return "";
    },
    getValueFromProtectionTypeText(value) {
      if (value == null) return null;
      var values = value.split("-");
      return parseInt(values[0]) || null;
    },
    getProtectionTypeById(id) {
      var value = this.protectionTypes.find((x) => x.id == id);
      if (value) return value.id + "-" + value.name;
      else return "";
    },
    setStyle: function (args) {
      if (
        args.column.field === "passwordValue" &&
        args.data["passwordValue"] != undefined &&
        args.data["passwordValue"] != null
      ) {
        if (args.data["passwordValue"].length > 0)
          args.cell.innerText = "********";
      }
    },
    setValues() {
      this.m_data = Object.assign({}, this.formData);

      var ds = this.getPackageListData();
      if (ds == undefined) this.gridPackagesData = [];
      else this.gridPackagesData = ds;

      this.setPackages();
      this.setDocuments();
      this.setFormats();
      this.setIntegrations();
    },
    setPackages() {
      this.packageSelected(this.gridPackagesData.filter((x) => x.selected));
      this.$refs.gridConditionPackages.ej2Instances.refresh();
    },
    setDocuments() {
      var documents = [];

      this.gridDocumentsData.forEach((item) => {
        var existent = this.m_data.documents.find(
          (x) =>
            x.packageId == item.packageId && x.documentId == item.documentId
        );

        if (existent != undefined && existent != null) {
          item.protectionTypeIdCombo = this.getProtectionTypeById(
            existent.protectionType
          );
          item.passwordValue = existent.passwordValue;
          item.selected = true;
        }
        documents.push(item);
      });

      this.gridDocumentsData = documents;
      this.documentSelected(this.gridDocumentsData.filter((x) => x.selected));
      this.$refs.gridConditionDocuments.ej2Instances.refresh();
    },
    setFormats() {
      var formats = [];
      this.gridFormatsData.forEach((item) => {
        var existent = this.m_data.formats.find(
          (x) =>
            x.packageId == item.packageId &&
            x.documentId == item.documentId &&
            x.formatId == item.formatId
        );
        if (existent != undefined && existent != null) {
          item.selected = true;
        }
        formats.push(item);
      });

      this.gridFormatsData = formats;
      this.$refs.gridConditionFormats.ej2Instances.refresh();
    },
    setIntegrations() {
      var integrations = [];
      this.gridIntegrationsData.forEach((item) => {
        var existent = this.m_data.integrations.find(
          (x) =>
            x.packageId == item.packageId &&
            x.integrationId == item.integrationId
        );
        if (existent != undefined && existent != null) {
          item.selected = true;
        }
        integrations.push(item);
      });

      this.gridIntegrationsData = integrations;
      this.$refs.gridConditionIntegrations.ej2Instances.refresh();
    }
  },

  props: {
    isMobile: {
      type: Boolean,
      required: true,
      default: false
    },
    showData: {
      type: Boolean,
      required: true,
      default: true
    }
  },
  provide: {
    grid: [Edit, Sort, Page, Selection, Toolbar, CommandColumn]
  }
});
</script>

<style>
@import url(../../../node_modules/@syncfusion/ej2-base/styles/fabric.css);
@import url(../../../node_modules/@syncfusion/ej2-vue-buttons/styles/fabric.css);
@import url(../../../node_modules/@syncfusion/ej2-dropdowns/styles/fabric.css);
@import url(../../../node_modules/@syncfusion/ej2-vue-calendars/styles/fabric.css);
@import url(../form-icons.css);

.dialog-papirus.e-dialog .e-dlg-header {
  color: #0078d6;
  font-size: 20px;
  font-weight: normal;
}

.content-wrapper div.row {
  padding: 5px 0px;
}

.switch-label {
  padding: 0px 0px 0px 20px;
  margin: auto;
  cursor: pointer;
}

.e-save.e-icons:before,
.e-save.e-icons:before {
  content: "\e609";
}

@media only screen and (max-width: 480px) {
  .content-wrapper {
    width: 92%;
  }

  .e-input-section .col-xs-6,
  .e-input-section .col-xs-4,
  .e-input-section .col-xs-12 {
    padding: 10px 5px;
    width: 100%;
  }

  .content-wrapper div.row {
    padding: 0px;
  }
}
</style>
